"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const app_button_module_scss_1 = __importDefault(require("./app-button.module.scss"));
const appStoreUrl = "https://apps.apple.com/us/app/camp-gladiator/id648465971?itsct=apps_box&amp;itscg=30200";
const googlePlayStoreUrl = "https://play.google.com/store/apps/details?id=com.campgladiator&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
const AppButton = (_a) => {
    var { brand, size, theme, className = "" } = _a, props = __rest(_a, ["brand", "size", "theme", "className"]);
    const link = brand === "Google Play" ? googlePlayStoreUrl : appStoreUrl;
    return (react_1.default.createElement("a", Object.assign({ href: link, className: `${app_button_module_scss_1.default.appButton} ${className}`, target: "_blank", "data-brand": brand, "data-size": size, "data-theme": theme }, props), brand));
};
exports.default = AppButton;
//# sourceMappingURL=app-button.js.map